<muni-gameday-tabbed-panel
  [condensed]="true"
  [activeTab]="activeTab"
  (changed)="onChange($event)"
  [subscribeOnChange]="true"
  [reactOnChange]="true"
>
  <muni-gameday-tab header="Managers Overview">
    <muni-gameday-loading [visible]="loading | async">
      <muni-gameday-managers-overview
        data-automation-e2e-selector="managers_overview_container"
      >
      </muni-gameday-managers-overview>
    </muni-gameday-loading>
  </muni-gameday-tab>
  <muni-gameday-tab header="Managers Retail">
    <muni-gameday-loading [visible]="loading | async">
      <muni-gameday-managers-retail-table
        data-automation-e2e-selector="managers_retail_container"
      >
      </muni-gameday-managers-retail-table>
    </muni-gameday-loading>
  </muni-gameday-tab>
  <muni-gameday-tab header="Accounts">
    <muni-gameday-loading [visible]="loading | async">
      <muni-gameday-accounts-reports
        data-automation-e2e-selector="accounts_reports_container"
      >
      </muni-gameday-accounts-reports>
    </muni-gameday-loading>
  </muni-gameday-tab>
</muni-gameday-tabbed-panel>
